import { extend, override } from "flarum/extend";
import IndexPage from "flarum/forum/components/IndexPage";

app.initializers.add("lltq-banners", (app) => {
  extend(IndexPage.prototype, "view", function (vdom) {
    if (vdom.children && vdom.children.splice) {
      const imageOne = app.forum.attribute("imageOne");
      const imageTwo = app.forum.attribute("imageTwo");
      const imageThree = app.forum.attribute("imageThree");
      const linkOne = app.forum.attribute("linkOne");
      const linkTwo = app.forum.attribute("linkTwo");
      const linkThree = app.forum.attribute("linkThree");
      const showTopBanners = !!Number(app.forum.attribute("showTopBanners"));

      const links = [
        [imageOne, linkOne],
        [imageTwo, linkTwo],
        [imageThree, linkThree],
      ].filter((x) => x[0] && x[1]);

      if (showTopBanners && links.length) {
        const element = (
          <div class="container slideshow-container">
            {links.map((banner) => {
              return (
                <div class="animated-slideshow-banner">
                  <a href={banner[1]} target="__blank" tabindex="-1">
                    <img src={banner[0]} alt="" />
                  </a>
                </div>
              );
            })}

            {links.length > 1 ? (
              <>
                <a class="prev">&#10094;</a>
                <a class="next">&#10095;</a>
              </>
            ) : (
              ""
            )}
          </div>
        );

        vdom.children.splice(0, 0, element);
      }
    }
  });

  extend(IndexPage.prototype, "oncreate", function (vnode) {
    const banners = document.getElementsByClassName(
      "animated-slideshow-banner"
    );
    const prevBtn = document.querySelector(".slideshow-container .prev");
    const nextBtn = document.querySelector(".slideshow-container .next");
    let bannerIdx = Math.floor(Math.random() * banners.length);
    let timer = Number(app.forum.attribute("timer"));
    timer = timer ? timer * 1000 : 5000;

    const showBanner = () => {
      for (let i = 0; i < banners.length; i++) {
        if (i !== bannerIdx - 1) {
          banners[i].classList.remove("shown");
        } else {
          banners[i].classList.toggle("shown");
        }
      }
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(rotateBanners, timer);
    };

    const rotateBanners = () => {
      bannerIdx += 1;
      if (bannerIdx > banners.length) {
        bannerIdx = 1;
      }
      showBanner();
    };

    const previousBanner = () => {
      bannerIdx -= 1;
      if (bannerIdx < 1) {
        bannerIdx = banners.length;
      }
      showBanner();
    };

    if (prevBtn) {
      prevBtn.onclick = previousBanner;
    }

    if (nextBtn) {
      nextBtn.onclick = rotateBanners;
    }

    rotateBanners();
  });

  extend(IndexPage.prototype, "onremove", function () {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  });

  extend(IndexPage.prototype, "view", function (vdom) {
    const showVerifiedBlock = !!Number(
      app.forum.attribute("showVerifiedBlock")
    );

    if (!showVerifiedBlock || app.current.data.routeName !== "index") return;

    if (vdom && vdom.children?.find) {
      let container = vdom.children.find(
        (el) => el.attrs?.className == "container"
      );

      if (container && container.children?.find) {
        let navContainer = container.children.find(
          (el) => el.attrs?.className == "sideNavContainer"
        );

        if (navContainer && navContainer.children?.find) {
          let insertAt = navContainer.children.find((el) =>
            el.attrs?.className.includes("IndexPage-results")
          );

          if (insertAt && insertAt.children) {
            let verifiedServices = null;

            try {
              verifiedServices = JSON.parse(
                app.forum.attribute("verifiedServices")
              );
            } catch (error) {}

            if (!verifiedServices || !Object.keys(verifiedServices).length) {
              return;
            }

            let verifiedServicesKeys = Object.keys(verifiedServices).sort(
              (a, b) => a - b
            );

            const element = (
              <div class="verified-block">
                <div class="verified-block-header">Доверенные сервисы</div>
                <div class="verified-block-content">
                  {verifiedServicesKeys.map((k) => {
                    return verifiedServices[k]?.link &&
                      verifiedServices[k]?.text ? (
                      <a
                        class="verified-block-link"
                        href={verifiedServices[k]?.link}
                        style="text-align:center; padding: 4px 8px"
                      >
                        {verifiedServices[k]?.text}
                      </a>
                    ) : (
                      ""
                    );
                  })}
                </div>
              </div>
            );

            insertAt.children.unshift(element);
          }
        }
      }
    }
  });
});
